module.exports = __webpack_public_path__ + "static/media/mycompanies.d9baab1a.svg";